import React, { useEffect, useState } from 'react'
import Input from '../../components/input';
import useAxiosInstance from '../../hooks/useAxios';
import JsonView from '@uiw/react-json-view';
import { toast } from 'react-toastify';
import PlaygroundV2Model from './PlaygroundV2Model';

const PlaygroundV2 = () => {
    const [prompt_function,set_prompt_function] = useState('');
    const [prompt_text,set_prompt_text] = useState('');
    const [system_prompt,set_system_prompt] = useState('');
    const [max_tokens,set_max_tokens] = useState('');
    // const [model,set_model] = useState({});
        
    const [model_parameters, set_model_parameters] = useState({})
    const axiosInstance = useAxiosInstance()
    
    const [library,set_library] = useState('');
    const [library_options,set_library_options] = useState([]);
    
    const [provider,set_provider] = useState('');
    const [provider_options,set_provider_options] = useState([]);
    
    const [model,set_model] = useState({});
    const [model_options,set_model_options] = useState([]);
    
    const [response, setResponse] = useState({});
    const [responseLoading,setResponseLoading] = useState(false);
    useEffect(()=>{
        axiosInstance.get('wkl/llm/get_library/').then(res=>
            set_library_options(res?.data?.data || [])
        ).catch()
    },[])
    
    useEffect(()=>{
        axiosInstance.get(`wkl/llm/get_provider/?library_pk=${library}`).then(res=>
            set_provider_options(res?.data?.data || [])
        ).catch()
    },[library])

    useEffect(()=>{
        axiosInstance.get(`wkl/llm/get_models/?provider_pk=${provider}`).then(res=>
            set_model_options(res?.data?.data || [])
        ).catch()
    },[provider])

    return (
      <PlaygroundV2Model
        max_tokens={max_tokens}
        model={model}
        prompt_function={prompt_function}
        prompt_text={prompt_text}
        set_max_tokens={set_max_tokens}
        set_model={set_model}
        set_prompt_function={set_prompt_function}
        set_prompt_text={set_prompt_text}
        set_system_prompt={set_system_prompt}
        system_prompt={system_prompt}
      />
    )
}

export default PlaygroundV2